

























import { CampaignSummary } from '@/usecases/novelty/campaign-summary'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { NoveltyRule } from '@/models/api/campaign/noveltyCampaign'
import { SkuSummary } from '@/usecases/novelty/sku-summary'
import { formatPrice } from '@/util/format'
import CountControl from '@spa/components/atoms/CountControl.vue'
import { PluginMixin } from '@spa/mixins/plugin'
import NoveltyItem from './NoveltyItem.vue'
import { Selection } from './selection'

@Component({
  components: {
    CountControl,
    NoveltyItem,
  },
})
export default class EditableNoveltyItem extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  summary: SkuSummary

  @Prop({ required: true })
  noveltySummary: CampaignSummary

  get show(): boolean {
    return this.summary.userCanChangeCount || this.summary.isOutOfStock
  }

  get rule(): NoveltyRule {
    return this.summary.rule
  }

  handleSelect(changedCount: number): void {
    this.emitSelect({
      skuId: this.summary.novelty.skuId,
      count: changedCount,
    })
  }

  @Emit('select')
  emitSelect(_selection: Selection) {
    // Do nothing
  }

  formatPrice(price: number): string {
    return formatPrice(price)
  }
}
